import { useState } from 'react';

// L'attrezzatura in sala e' PER SERATA, non e' l'inventario della location.
// Un locale puo' avere le tastiere tutto l'anno e non averle disponibili
// stasera: qui si tocca solo la serata, l'elenco della location resta
// intatto e si modifica dalla sua scheda.
import { addEventEquipmentItem, removeEventEquipmentItem, setEventEquipment,
         addMusicianEquipment, removeMusicianEquipment } from '../lib/supabase';
import { firstName } from '../helpers';

function EquipmentSection({ eventId, equipment, musicianEquipment, musicians, currentUser, canManage, onRefresh, venue, venueEquipmentList }) {
  const [myItem, setMyItem] = useState('');
  const [venueItem, setVenueItem] = useState('');
  const [busy, setBusy] = useState(false);
  const isMusicianUser = currentUser.accountType === 'musician';
  const getName = (id) => firstName(musicians.find(m => m.id === id)?.name || '?');

  const inSala = equipment || [];
  const nomiInSala = new Set(inSala.map(e => (e.item || '').trim().toLowerCase()));
  // Cosa la location ha di solito ma stasera non e' segnato.
  const mancanti = (venueEquipmentList || [])
    .map(e => e.item)
    .filter(item => item && !nomiInSala.has(item.trim().toLowerCase()));

  const aggiungi = async (item) => {
    if (!item.trim() || busy) return;
    setBusy(true);
    try { await addEventEquipmentItem(eventId, item.trim()); await onRefresh(); }
    finally { setBusy(false); }
  };
  const rimuovi = async (id) => {
    setBusy(true);
    try { await removeEventEquipmentItem(id); await onRefresh(); }
    finally { setBusy(false); }
  };
  const riprendiDallaLocation = async () => {
    setBusy(true);
    try {
      await setEventEquipment(eventId, (venueEquipmentList || []).map(e => e.item));
      await onRefresh();
    } finally { setBusy(false); }
  };

  return (
    <div>
      {/* ── In sala per questa serata ── */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize:16, fontWeight:700, color:'var(--muted)', textTransform:'uppercase', letterSpacing:'0.07em', marginBottom: 4 }}>
          In sala per questa serata
        </div>
        {canManage && (
          <div style={{ fontSize:16, color:'var(--muted)', marginBottom:10, lineHeight:1.5 }}>
            Vale solo per questa serata. L'elenco della location non cambia.
          </div>
        )}

        {inSala.length === 0 && (
          <div style={{ fontSize:17, color:'var(--muted)', marginBottom:10 }}>
            Niente indicato per questa serata.
          </div>
        )}
        {inSala.map((eq, i, arr) => (
          <div key={eq.id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 0', borderBottom: i < arr.length - 1 ? '1px solid rgba(255,255,255,0.06)' : 'none' }}>
            <span style={{ fontSize:17, color:'var(--text)' }}>{eq.item}</span>
            {canManage && (
              <button onClick={() => rimuovi(eq.id)} disabled={busy}
                aria-label={`Togli ${eq.item} da questa serata`}
                style={{ display:'flex', alignItems:'center', justifyContent:'center', width:44, height:44, flexShrink:0,
                  background:'none', border:'none', color:'rgba(255,82,82,0.75)', cursor:'pointer', padding:0 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>
              </button>
            )}
          </div>
        ))}

        {canManage && (
          <div style={{ display:'flex', gap:8, marginTop:12 }}>
            <input value={venueItem} onChange={e => setVenueItem(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') { aggiungi(venueItem); setVenueItem(''); } }}
              placeholder="Aggiungi cosa c'e' in sala..."
              style={{ flex:1, background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.12)', borderRadius:9, padding:'11px 12px', color:'var(--text)', fontSize:17, outline:'none', fontFamily:'inherit' }}
            />
            <button onClick={() => { aggiungi(venueItem); setVenueItem(''); }} disabled={busy}
              style={{ padding:'11px 16px', borderRadius:9, border:'none', background:'rgba(237,77,29,0.12)', color:'var(--brand)', fontWeight:700, fontSize:16, cursor:'pointer', flexShrink:0, minHeight:44 }}>
              Aggiungi
            </button>
          </div>
        )}

        {/* Cosa la location ha di solito: si riprende a mano, mai da sola. */}
        {canManage && venue && mancanti.length > 0 && (
          <div style={{ marginTop:14, padding:'12px 14px', borderRadius:10, background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.07)' }}>
            <div style={{ fontSize:16, color:'var(--muted)', marginBottom:8, lineHeight:1.5 }}>
              {venue.name} di solito ha anche:
            </div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
              {mancanti.map(item => (
                <button key={item} onClick={() => aggiungi(item)} disabled={busy}
                  style={{ padding:'9px 14px', borderRadius:999, border:'1px solid rgba(237,77,29,0.3)', background:'rgba(237,77,29,0.06)', color:'var(--brand)', fontSize:16, fontWeight:600, cursor:'pointer', minHeight:44 }}>
                  + {item}
                </button>
              ))}
            </div>
            {inSala.length === 0 && (
              <button onClick={riprendiDallaLocation} disabled={busy}
                style={{ marginTop:10, background:'none', border:'none', color:'var(--brand)', fontSize:16, fontWeight:700, cursor:'pointer', padding:'8px 0', minHeight:44 }}>
                Riprendi tutto l'elenco della location
              </button>
            )}
          </div>
        )}

        {canManage && !venue && (
          <div style={{ fontSize:16, color:'var(--muted)', marginTop:10 }}>
            Nessuna location associata alla serata.
          </div>
        )}
      </div>

      {/* ── Portati dai musicisti ── */}
      <div>
        <div style={{ fontSize:16, fontWeight:700, color:'var(--muted)', textTransform:'uppercase', letterSpacing:'0.07em', marginBottom:10 }}>
          Portati dai musicisti
        </div>

        {musicianEquipment.length === 0 && (
          <div style={{ fontSize:17, color:'var(--muted)', marginBottom:10 }}>Nessuno ha ancora indicato cosa porta.</div>
        )}
        {musicianEquipment.map((eq, i, arr) => (
          <div key={eq.id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 0', borderBottom: i < arr.length - 1 ? '1px solid rgba(255,255,255,0.06)' : 'none' }}>
            <div>
              <span style={{ fontSize:17, color:'var(--text)' }}>{eq.item}</span>
              <span style={{ fontSize:16, color:'var(--muted)', marginLeft:8 }}>— {getName(eq.musician_id)}</span>
            </div>
            {(eq.musician_id === currentUser.id || canManage) && (
              <button onClick={async () => { await removeMusicianEquipment(eq.id); onRefresh(); }}
                style={{ background:'none', border:'none', color:'rgba(255,82,82,0.6)', fontSize:16, cursor:'pointer', padding:'2px 0 2px 16px' }}>
                Rimuovi
              </button>
            )}
          </div>
        ))}

        {isMusicianUser && (
          <div style={{ display:'flex', gap:8, marginTop:10 }}>
            <input style={{ flex:1, background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:9, padding:'9px 12px', color:'var(--text)', fontSize:17, outline:'none', fontFamily:'inherit' }}
              placeholder="Cosa porti? (es. Ampli chitarra...)"
              value={myItem} onChange={e => setMyItem(e.target.value)}
              onKeyDown={async e => { if (e.key === 'Enter' && myItem.trim()) { await addMusicianEquipment(eventId, currentUser.id, myItem.trim()); setMyItem(''); onRefresh(); } }}
            />
            <button onClick={async () => { if (myItem.trim()) { await addMusicianEquipment(eventId, currentUser.id, myItem.trim()); setMyItem(''); onRefresh(); } }}
              style={{ padding:'9px 16px', borderRadius:9, border:'none', background:'#ED4D1D', color:'#fff', fontWeight:700, fontSize:16, cursor:'pointer', flexShrink:0 }}>
              Porto io
            </button>
          </div>
        )}
      </div>

    </div>
  );
}

export default EquipmentSection;
